import styled from 'styled-components';

export const List = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const Li = styled.li`
  list-style: none;
  padding: 0;
  margin: 0;
`

